import React, { useState } from "react";
import instance from "../../api/api";
import InputCreate from "../../features/InputCreate";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate } from "react-router-dom";
import Button from "../../features/Button";
// import { FaArrowLeft } from "react-icons/fa";
import { Header } from "../../shared/compoments";
const styleBtn = {
  padding: ".5em",
  borderRadius: "5px",
  fontWeight: "bold",
  cursor: "pointer",
  color: "black",
  backgroundColor: "rgb(255 177 47 / 99%)",
  marginTop: "1em",
  border: "none",
};

function CreateCommodite() {
  const navigate = useNavigate();

  const MySwal = withReactContent(Swal);

  const [isLoading, setIsLoading] = useState(false);

  const [dataCommodite, setDataCommodite] = useState({
    label: "",
  });
  const saveCommodite = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await instance.post("comodites", dataCommodite);

      console.log(response);
      if (response.data.status === false) {
        let msgError = [];
        for (const property in response.data.message) {
          msgError = [...msgError, response.data.message[property]];
        }
        MySwal.fire({
          title: msgError,
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setDataCommodite({
          label: "",
        });

        MySwal.fire({
          title: "Enregistrement reussi.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Header libelle={"Enregistrer une commodité"} isReturn />
      <form onSubmit={saveCommodite} className="create-user">
        <div className="row g-3">
          <div className="col-lg-6">
            <InputCreate
              label="Libellé"
              typeInput="text"
              nameInput="Libelle"
              active={true}
              getValue={(e) => {
                setDataCommodite({ ...dataCommodite, label: e.target.value });
              }}
              dataValue={dataCommodite.label}
            />
          </div>
          <div className="col-lg-12 d-flex align-items-end">
            <Button
              titre="Enregistrer"
              styleBtn={styleBtn}
              isLoading={isLoading}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateCommodite;
